import React from "react"
import { graphql } from "gatsby"

// We're using Gutenberg so we need the block styles
// these are copied into this project due to a conflict in the postCSS
// version used by the Gatsby and @wordpress packages that causes build
// failures.
// @todo update this once @wordpress upgrades their postcss version
import "../css/@wordpress/block-library/build-style/style.css"
import "../css/@wordpress/block-library/build-style/theme.css"

import Layout from "../components/layout"
import Seo from "../components/seo"

import ExploreMission from "../components/GlobalComponents/ExploreMill/ExploreMission"
import MillieniumMemberSection from "../components/GlobalComponents/MillieniumMemberSection/MillieniumMemberSection"
import PostsNavigation from "../components/SingleArticle/PostsNavigation/PostsNavigation"
import LatestNews from "../components/SinglePost/LatestNews/LatestNews"
import PostContent from "../components/SinglePost/PostContent/PostContent"
import HeroBanner from "../components/SingleArticle/HeroBanner"

const BlogPostTemplate = ({ data: { previous, next, post, latestPosts } }) => {
  return (
    <Layout>
      <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <Seo title={post.seo.title} description={post.seo.metaDesc || post.excerpt } image={post.featuredImage?.node?.localFile?.publicURL} />
        <HeroBanner data={post} isSingle={true} />
        <PostContent data={post} />
      </article>
      <PostsNavigation data={{ previous: next, next: previous }} />
      <LatestNews data={latestPosts} />
      <MillieniumMemberSection />
      <ExploreMission />
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostById(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      seo {
        title
        metaDesc
      }
      title
      date(formatString: "DD MMM - YYYY")
      categories {
        nodes {
          name
          uri
          slug
        }
      }
      author {
        node {
          name
        }
      }
      featuredImage {
        node {
          localFile {
            publicURL
          }
        }
      }
    }
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
      featuredImage {
        node {
          altText
          localFile {
            publicURL
          }
        }
      }
    }
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
      featuredImage {
        node {
          altText
          localFile {
            publicURL
          }
        }
      }
    }
    latestPosts: allWpPost(limit: 2) {
      nodes {
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
              publicURL
            }
          }
        }
        title
        uri
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
            uri
          }
        }
        date(formatString: "DD MMM")
        content
      }
    }
  }
`
